/**
 * Mortgage Configuration API
 * Fetches mortgage configuration from backend config system
 */

import { authFetch } from '../api';

/**
 * Get mortgage configuration from backend (cached in memory)
 * @param {string} propertyId - Optional property ID for property-specific overrides
 * @returns {Promise<Object>} Mortgage config data
 */
export async function getMortgageConfig(propertyId = null) {
  try {
    const url = propertyId
      ? `/config/mortgage?property_id=${propertyId}`
      : '/config/mortgage';
    const response = await authFetch(url);
    return response;
  } catch (error) {
    console.error('Error fetching mortgage config:', error);
    throw error;
  }
}
